import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Typography,
  makeStyles,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import EventIcon from "@material-ui/icons/Event";
import { useParams } from "react-router-dom";
import CircularIndeterminate from "../../components/shared/CircleLoader";
import LocationService from "../../services/LocationService";
import swal from "sweetalert";
import moment from "moment";
const useStyles = makeStyles((theme) => ({
  vendorCard: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 12px 20px rgba(0, 0, 0, 0.1)",
    },
  },
  vendorName: {
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
  },
  vendorInfo: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  icon: {
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  avatar: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    fontSize: "1.5rem",
  },
  cardContent: {
    flex: 1,
  },
  vendorsContainer: {
    marginTop: theme.spacing(3),
    width: "100%",
  },
  vendorsHeader: {
    marginBottom: theme.spacing(3),
  },
  cardFooter: {
    display: "flex",
    justifyContent: "space-between",
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1.5),
    marginTop: "auto",
  },
  footerButton: {
    minWidth: "auto",
  },
  editButton: {
    color: theme.palette.info.main,
    "&:hover": {
      backgroundColor: "transparent",
      color: theme.palette.info.main,
    },
  },
  deleteButton: {
    color: theme.palette.error.main,
    "&:hover": {
      backgroundColor: "red",
      color: "#fff",
    },
  },
}));

const LocationManagementPage = ({ history }) => {
  const classes = useStyles();
  const { locationId } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [locationName, setLocationName] = useState("");
  const [vendors, setVendors] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [vendorToDelete, setVendorToDelete] = useState(null);

  useEffect(() => {
    setLoading(true);
    const locationService = new LocationService();
    const getLocation = async () => {
      const { data } = await locationService.getVendors(locationId);
      console.log(data.data);
      setVendors(data.data.vendors);
      setLocationName(data.data.location.name);
    };
    getLocation();
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goToPage = () => {
    history.push({
      pathname: `/revenue/lot/${locationId}/new`,
    });
  };

  const getInitials = (name) => {
    console.log("name!!!!!", name);
    console.log("vendors!!!!!", vendors);
    return name
      ? name
          .split(" ")
          .map((word) => word[0])
          .join("")
          .toUpperCase()
      : "";
  };

  const handleEditVendor = (vendorId) => {
    console.log("Edit vendor:", vendorId);
    history.push({
      pathname: `/management/locations/${locationId}/vendors/${vendorId}/edit`,
    });
  };

  const handleDeleteVendor = (vendorId) => {
    const vendor = vendors.find((v) => v._id === vendorId);
    setVendorToDelete(vendor);
    setDeleteModalOpen(true);
  };

  const confirmDeleteVendor = () => {
    // Implement actual delete logic
    setVendors(vendors.filter((v) => v._id !== vendorToDelete._id));
    setDeleteModalOpen(false);
    setVendorToDelete(null);

    console.log("vendor!!!!!", vendorToDelete);
    console.log("vendorId!!!!!", vendorToDelete._id);

    fetch(`/api/v1/locations/${locationId}/vendors/${vendorToDelete._id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        swal.fire({
          title: "Success",
          text: "Vendor deleted successfully",
          icon: "success",
        });
      })
      .catch((err) => console.log(err));
  };

  const cancelDeleteVendor = () => {
    setDeleteModalOpen(false);
    setVendorToDelete(null);
  };

  const goToAddVendor = () => {
    console.log("Add vendor");
    history.push({
      pathname: `/management/locations/${locationId}/vendors/add`,
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 20,
        alignItems: "center",
        marginTop: 30,
      }}
    >
      {isLoading ? (
        <CircularIndeterminate />
      ) : locationName ? (
        <>
          <Typography variant="h4" style={{ textTransform: "capitalize" }}>
            {locationName}
          </Typography>
          <div>
            <Button
              variant="contained"
              color="primary"
              disabled={isLoading}
              onClick={goToPage}
              style={{ color: "#fff", width: "280px", marginBottom: "20px" }}
            >
              Add Session
            </Button>
          </div>
          <Divider
            style={{ width: "100%", marginTop: "10px", marginBottom: "10px" }}
          />

          <div className={classes.vendorsContainer}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <Typography variant="h4" className={classes.vendorsHeader}>
                Vendors
              </Typography>
              <Button
                style={{
                  color: "#000",
                  border: "1px solid #000",
                  marginBottom: 20,
                }}
                startIcon={<AddIcon />}
                onClick={goToAddVendor}
              >
                Add Vendor
              </Button>
            </div>
            <Grid container spacing={3}>
              {vendors.length > 0 ? (
                vendors.map((vendor) => (
                  <Grid item xs={12} sm={6} md={4} key={vendor._id}>
                    <Card className={classes.vendorCard} elevation={3}>
                      <CardContent className={classes.cardContent}>
                        <div style={{ textAlign: "center" }}>
                          <Avatar className={classes.avatar}>
                            {getInitials(vendor.name)}
                          </Avatar>
                        </div>
                        <Typography
                          variant="h6"
                          className={classes.vendorName}
                          style={{ textTransform: "capitalize" }}
                        >
                          {vendor.name}
                        </Typography>
                        <div className={classes.vendorInfo}>
                          <AssignmentIndIcon className={classes.icon} />
                          <Typography
                            variant="body2"
                            style={{
                              fontWeight: "bold",
                              display: "flex",
                              alignItems: "center",
                              gap: 5,
                            }}
                          >
                            Code:{" "}
                            <Typography
                              variant="body2"
                              style={{ textTransform: "uppercase" }}
                            >
                              {vendor.code}
                            </Typography>
                          </Typography>
                        </div>
                        {/* <div className={classes.vendorInfo}>
                          <DirectionsCarIcon className={classes.icon} />
                          <Typography variant="body2">
                            Plates: {vendor.plate.join(", ")}
                          </Typography>
                        </div> */}
                        <div className={classes.vendorInfo}>
                          <EventIcon className={classes.icon} />
                          <Typography
                            variant="body2"
                            style={{
                              fontWeight: "bold",
                              display: "flex",
                              alignItems: "center",
                              gap: 5,
                            }}
                          >
                            Expires:{" "}
                            <Typography variant="body2">
                              {moment.utc(vendor.expirationDate).format("LL")}
                            </Typography>
                          </Typography>
                        </div>
                      </CardContent>
                      <div className={classes.cardFooter}>
                        <Button
                          className={`${classes.footerButton} ${classes.editButton}`}
                          startIcon={<EditIcon />}
                          size="small"
                          onClick={() => handleEditVendor(vendor._id)}
                        >
                          Edit
                        </Button>
                        <Button
                          className={`${classes.footerButton} ${classes.deleteButton}`}
                          startIcon={<DeleteIcon />}
                          size="small"
                          onClick={() => handleDeleteVendor(vendor._id)}
                        >
                          Delete
                        </Button>
                      </div>
                    </Card>
                  </Grid>
                ))
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    width: "100%",
                    marginTop: 200,
                  }}
                >
                  <Typography variant="h6">No vendors found</Typography>
                </div>
              )}
            </Grid>
          </div>
        </>
      ) : (
        <div>No locations found</div>
      )}

      {/* Delete Confirmation Modal */}
      <Dialog
        open={deleteModalOpen}
        onClose={cancelDeleteVendor}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete vendor "{vendorToDelete?.name}"?
            This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={cancelDeleteVendor}
            color="primary"
            className={classes.editButton}
          >
            Cancel
          </Button>
          <Button
            onClick={confirmDeleteVendor}
            color="secondary"
            autoFocus
            className={classes.deleteButton}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default LocationManagementPage;
